export default __webpack_public_path__ + "static/media/alex6.c686b733.jpg";